import type { ProjectId } from 'owa-timestream-types';
import todoFolderIdMap from './todoFolderIdMap';

export default function updateTodoFolderIdMap(
    projectId: ProjectId,
    todoFolderIdPromise: Promise<string>
) {
    todoFolderIdMap.set(projectId, todoFolderIdPromise);
    todoFolderIdPromise.then(todoFolderId => todoFolderIdMap.set(projectId, todoFolderId));
}
